import React, { useState } from 'react';
import styled from 'styled-components';
import { Table, Thead, Tbody, Row, HeadingCell, Cell } from './StyledTable';
import { ResolvedReportScheduleSlice, ReportTemplateSlice } from '../../../store/data-export/types';
import { ScheduleRow } from './ScheduleRow';

const StyledSchedules = styled.div`

`;

export const Schedules = ({ reportSchedules, reportTemplates }: { reportSchedules: ResolvedReportScheduleSlice[]; reportTemplates: ReportTemplateSlice[] }) => {
  
  const [toggle, setToggle] = useState(true);
  
  return (
    <StyledSchedules>
      <Table>
        <Thead>
          <Row>
            <HeadingCell></HeadingCell>
            <HeadingCell centered={true}>Report</HeadingCell>
            <HeadingCell centered={true}>Positions</HeadingCell>
            <HeadingCell centered={true}>Period</HeadingCell>
            <HeadingCell centered={true}>Recipients</HeadingCell>
            <HeadingCell centered={true}>Enabled</HeadingCell>
            <HeadingCell></HeadingCell>
          </Row>
        </Thead>
        <Tbody>
          {reportSchedules.map(schedule => (
            <ScheduleRow key={schedule.id} schedule={schedule} reportTemplates={reportTemplates}/>
          ))}
        </Tbody>
      </Table>
    </StyledSchedules>
  )
}